import React, { useEffect, useMemo, useState } from "react";
import RoleToggle from "../../components/RoleToggle";
import InventoryCheckTab from "./_components/InventoryCheckTab";
import InventoryTab from "./_components/InventoryTab";
import ItemInventory from "./_components/ItemInventory";
import { useSelector } from "react-redux";
import { selectClientPermissions } from "../../features/auth/authSlice";
// import ProductItemsMovement from "./_components/ProductMovement";
// import LeadWMSDashboard from "./_components/WarehouseDashboard";

interface TabConfig {
  key: string;
  label: string;
  component: React.ReactNode;
  modules: string[];
  operation: "read";
}

const hasPermission = (
  permissions: ReturnType<typeof selectClientPermissions>,
  modules: string[],
  operation: "read"
) => {
  if (!permissions) return false;
  return modules.some((mod) =>
    permissions.some((p) => p.module === mod && p.operations.includes(operation))
  );
};

const InventoryTabMain: React.FC = () => {
  const permissions = useSelector(selectClientPermissions);
  const outerTabs: TabConfig[] = useMemo(
    () => [
      {
        key: "ShipmentInventory",
        label: "Shipment Inventory",
        component: null,
        modules: ["shipment_inventory"],
        operation: "read",
      },
       
    ],
    []
  );

  const innerTabsForShipment: TabConfig[] = useMemo(
    () => [
      {
        key: "Inventory",
        label: "Inventory",
        component: <InventoryTab />,
        modules: ["shipment_inventory"],
        operation: "read",
      },
      {
        key: "InventoryCheck",
        label: "Inventory Check",
        component: <InventoryCheckTab />,
        modules: ["shipment_inventory"],
        operation: "read",
      },
    ],
    []
  );

  const visibleOuter = useMemo(
    () => outerTabs.filter((t) => hasPermission(permissions, t.modules, "read")),
    [permissions, outerTabs]
  );

  const visibleInner = useMemo(
    () =>
      innerTabsForShipment.filter((t) =>
        hasPermission(permissions, t.modules, "read")
      ),
    [permissions, innerTabsForShipment]
  );

  const shouldShowShipmentOuter =
    visibleOuter.some((t) => t.key === "ShipmentInventory") && visibleInner.length > 0;

  const finalVisibleOuter = useMemo(() => {
    if (!shouldShowShipmentOuter) {
      return visibleOuter.filter((t) => t.key !== "ShipmentInventory");
    }
    return visibleOuter;
  }, [visibleOuter, shouldShowShipmentOuter]);

  const [activeOuter, setActiveOuter] = useState<string>(() => {
    const saved = localStorage.getItem("InventoryWiseActiveRole");
    return saved && finalVisibleOuter.some((t) => t.key === saved)
      ? saved
      : finalVisibleOuter[0]?.key ?? "";
  });

  useEffect(() => {
    if (activeOuter) localStorage.setItem("InventoryWiseActiveRole", activeOuter);
  }, [activeOuter]);


  const [activeInner, setActiveInner] = useState<string>(() => {
    const saved = localStorage.getItem("InventoryCheckActiveRole");
    return saved && visibleInner.some((t) => t.key === saved)
      ? saved
      : visibleInner[0]?.key ?? "";
  });

  useEffect(() => {
    if (activeInner) localStorage.setItem("InventoryCheckActiveRole", activeInner);
  }, [activeInner]);

  useEffect(() => {
    if (finalVisibleOuter.length && !finalVisibleOuter.some((t) => t.key === activeOuter)) {
      setActiveOuter(finalVisibleOuter[0].key);
    }
  }, [finalVisibleOuter, activeOuter]);

  useEffect(() => {
    if (
      activeOuter === "ShipmentInventory" &&
      visibleInner.length &&
      !visibleInner.some((t) => t.key === activeInner)
    ) {
      setActiveInner(visibleInner[0].key);
    }
  }, [visibleInner, activeInner, activeOuter]);

  const activeOuterTab = finalVisibleOuter.find((t) => t.key === activeOuter);
  const activeInnerTab = visibleInner.find((t) => t.key === activeInner);

  if (finalVisibleOuter.length === 1 && finalVisibleOuter[0].key === "ItemsInventory") {
    return (
      <div className="space-y-4">
        <ItemInventory />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {finalVisibleOuter.length > 1 && (
        <div className="flex justify-between items-center">
          <RoleToggle
            options={finalVisibleOuter.map((t) => t.label)}
            active={activeOuterTab?.label ?? ""}
            onChange={(label) => {
              const tab = finalVisibleOuter.find((t) => t.label === label);
              if (tab) setActiveOuter(tab.key);
            }}
          />
        </div>
      )}

      {activeOuter === "ShipmentInventory" && visibleInner.length > 0 && (
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <RoleToggle
              options={visibleInner.map((t) => t.label)}
              active={activeInnerTab?.label ?? ""}
              onChange={(label) => {
                const tab = visibleInner.find((t) => t.label === label);
                if (tab) setActiveInner(tab.key);
              }}
            />
          </div>

          {activeInner === "Inventory" && <InventoryTab />}
          {activeInner === "InventoryCheck" && <InventoryCheckTab />}
        </div>
      )}

      {activeOuter === "ItemsInventory" && (
        <div className="space-y-4">
          <ItemInventory />
        </div>
      )}

       {/* {activeOuter === "ProductItemsMovement" && (
        <div className="space-y-4">
          <ProductItemsMovement />
        </div>
      )} */}

      {/* {activeOuter === "inventoryHeatMap" && (
        <div className="space-y-4">
          <LeadWMSDashboard />
        </div>
      )} */}
    </div>
  );
};

export default InventoryTabMain;